import {BaseServiceOrder} from "@pages/AdditionalServices/containers/services/servicesOrder/BaseServiceOrder";

// servicesOrder реализует сортировку услуг
const servicesOrder = () => new BaseServiceOrder

export default servicesOrder